'use client'

import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useIsAuthenticated, useIsPunchout } from '@/lib/auth/client/AuthProvider.client'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { UsePunchoutCartIdDocument } from '@gql-generated/graphql'
import { useCallback } from 'react'

gql(/* GraphQL */ `
  query UsePunchoutCartId {
    currentUser {
      id
      punchout {
        cart {
          id
        }
      }
    }
  }
`)

type UsePunchoutCartIdResult = {
  punchoutCartId?: number
  resolvePunchoutCartId: () => Promise<number | undefined>
}

export function usePunchoutCartId(): UsePunchoutCartIdResult {
  const isAuthenticated = useIsAuthenticated()
  const isPunchout = useIsPunchout()

  const { data, refetch } = useQuery(UsePunchoutCartIdDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    skip: !isAuthenticated || !isPunchout,
  })

  const punchoutCartId = data?.currentUser?.punchout?.cart?.id

  const resolvePunchoutCartId = useCallback(async () => {
    if (punchoutCartId) return punchoutCartId

    const { data: refetched } = await refetch()

    return refetched?.currentUser?.punchout?.cart?.id
  }, [punchoutCartId, refetch])

  return { punchoutCartId, resolvePunchoutCartId }
}
